<footer class="footer">
  <div class="container-core">
    <div class="footer-box">
      <div class="footer-info">
        <span> © {{ year }}</span>
        Control Insurance Solutions Pty Ltd.
        <br />
        This Website is hosted by Control Insurance Solutions.
        <br />
        <a
          class="footer-info__link"
          href="https://controlinsurancesolutions.com.au/website-terms-of-use"
          target="_blank"
          >Terms Of Use</a
        >
        |
        <a
          class="footer-info__link"
          href="https://controlinsurancesolutions.com.au/privacy-policy"
          target="_blank"
          >Privacy Policy</a
        >
      </div>
    </div>
  </div>
</footer>
